import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getUsers } from 'api/Roles';

export const useRoleUsers = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['useRoleUsers', ...dependencies], () => getUsers(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options
  });
};
